import React, { useState, useContext } from "react";
import { ErrorIndicator, Heading1, Paragraph } from "../shared/layout";
import { Input } from "../shared/utilities";
import { useNavigate } from "react-router-dom";
import { axios } from "../middleware/axios";
import SessionContext from "../context/session";
import Button from "../components/Button";
import ClaudeLogo from "../components/Brand/Logo";
import InlineNotification from "../components/InlineNotification";
import "./Home.css";

const Home = () => {
  const { setToken, name, setName, setSessionStart } =
    useContext(SessionContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleInput = (event: any) => {
    setName(event.target.value);
  };

  const CREATE_SESSION = async () => {
    try {
      setLoading(true);
      const token = await axios.post(`/token?name=${name}`);
      setToken(token?.data.token);
      setName(token?.data.name);
      setSessionStart(token?.data.session_start);
      setLoading(false);
      navigate(`chat/${token.data.token}`);
    } catch (error: any) {
      setLoading(false);
      if (error?.message === "timeout exceeded") {
        setError("发生未知错误，请稍后再试");
      } else if (error?.response.status === 400) {
        setError("错误！请填写必要的信息");
      } else {
        setError("发生未知错误，请稍后再试");
      }
    }
  };

  const onSubmit = (event: any) => {
    event.preventDefault();
    if (name.length > 0) {
      CREATE_SESSION();
    } else {
      setError("错误！请填写必要的信息");
    }
  };

  return (
    <div className="home">
      <div className="home-hero">
        <div className="home-hero__mark">
          <ClaudeLogo size={44} />
        </div>
        <Heading1>今天有什么可以帮你的？</Heading1>
        <Paragraph className="home-hero__subtitle">
          基于 Python、Redis、React 和 FastAPI 构建的对话式 AI 助手。输入你的名字，
          开启一次新的对话。
        </Paragraph>
      </div>

      {loading ? (
        <div className="home-loader">
          <ClaudeLogo size={30} />
          <Paragraph>正在创建会话…</Paragraph>
        </div>
      ) : (
        <form className="home-form" onSubmit={onSubmit}>
          <Input
            placeholder="输入你的名字以开始对话"
            value={name}
            type="text"
            onChange={handleInput}
            autoFocus
          />
          <Button kind="secondary" text={"开始对话"} hasIcon={true} />
          {error ? <ErrorIndicator>{error}</ErrorIndicator> : null}
        </form>
      )}

      <div className="home-disclaimers">
        <InlineNotification kind={"warning"}>
          AI 的回复难以预测，可能会在没有预警的情况下产生冒犯性内容。
        </InlineNotification>
        <InlineNotification kind={"neutral"}>
          这是仅用于测试的开发版本，不适用于生产环境，也不保证结果的准确性。
        </InlineNotification>
      </div>
    </div>
  );
};

export default Home;
